/**
 * 変更で所属フォームを送信する汎用部品（data 属性駆動。introduce-groups design.md D3）
 *
 * マークアップ規約:
 *   <form method="get" action="/admin/users">
 *     <select name="group" data-lms-auto-submit>…</select>
 *     <button type="submit">表示</button>   ← JS 無効時のフォールバック（必須）
 *   </form>
 *
 * form.submit() ではなく form.requestSubmit() を使う。submit() は submit イベントを
 * 発火させないため htmx の hx-boost が横取りできず、部分更新ではなく全画面遷移になる
 * （ADR-0011 に反する）。requestSubmit() は通常の送信と同じくイベントを発火する。
 *
 * 送信ボタンを持たないフォームには使わない（requestSubmit() は制約検証を行うため、
 * 無効な入力があると送信されない。グループ選択は select のみで常に有効値）。
 */
export function initAutoSubmit(scope: ParentNode = document): void {
  scope.querySelectorAll<HTMLSelectElement>("select[data-lms-auto-submit]").forEach((select) => {
    if (select.dataset["lmsAutoSubmitReady"] === "1") return;
    select.dataset["lmsAutoSubmitReady"] = "1";

    select.addEventListener("change", () => {
      const form = select.form;
      if (form) form.requestSubmit();
    });
  });
}
